import React, { useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Button } from '@sololearnorg/sol';
import s from './SkipAheadWidget.scss';
import { IMaterialProps } from '../../../../global-interface';
import { SkipIcon } from '../../../../../../shared/public/assets/icons/SkipIcon';
import { Container, i18n } from '../../../../../../symphony';
import { SlLEContext } from '../../../../global-constants';
import { SlEventsService } from '../../../../services/Business/sl-events.service';
import { SlInfoScreen } from '../../../../../../shared/public/SlInfoScreen/SlInfoScreen';
import { SkipFastIcon } from '../../../../../../shared/public/assets/icons/SkipFastIcon';

export const SkipAheadWidget = ({ materialInfo }: IMaterialProps) => {
	useStyles(s);

	const eventService = Container.take(SlLEContext, SlEventsService);

	const [showScreen, setShowScreen] = useState(false);

	const handleButtonClick = () => {
		setShowScreen(true);
	};

	const handleContinueClick = () => {
		setShowScreen(false);
		eventService.onSkipAheadJumpClick(materialInfo.header.dynamicId);
	};

	return (
		<>
			{showScreen && (
				<SlInfoScreen
					showCloseIcon
					buttonTitle={i18n.t('skip-ahead.info.cta')}
					reward={{
						showReward: false,
					}}
					title={i18n.t('skip-ahead.info.title')}
					subTitle={i18n.t('skip-ahead.info.subtitle')}
					icon={<SkipFastIcon />}
					onCloseClick={() => setShowScreen(false)}
					onButtonClick={handleContinueClick}
				/>
			)}
			<div className="sl-skip-ahead-widget">
				<SkipIcon />
				<p className="sl-skip-ahead-widget__info">
					{i18n.t('skip-ahead.widget.title')}
				</p>
				<Button
					buttonType="secondary"
					onClick={handleButtonClick}
				>
					{i18n.t('skip-ahead.widget.cta')}
				</Button>
			</div>
		</>
	);
};
